import request from '@/base/service'
const sys = '/tcloud-account'

//  普通登录接口
export function login(data) {
  return request({
    url: '/tcloud-sso/account/login',
    method: 'post',
    params: data
  })
}

//  注销
export function logout() {
  return request({
    url: '/tcloud-sso/account/logout',
    method: 'post'
  })
}

// 检查用户名重复
export function checkLoginName(loginName) {
  return request({
    url: '/tcloud-sso/account/checkLoginName?loginName=' + loginName,
    method: 'get'
  })
}

// 注册账号时发送手机验证码
export function registerSendPhoneSecode(data) {
  return request({
    url: '/tcloud-sso/account/registerSendPhoneSecode',
    method: 'post',
    params: data
  })
}

// 注册
export function register(data) {
  return request({
    url: '/tcloud-sso/account/register',
    method: 'post',
    data
  })
}

// 登录发送手机验证码
export function sendPhoneSecode(data) {
  return request({
    url: '/tcloud-sso/account/sendPhoneSecode',
    method: 'get',
    params: data
  })
}

// 手机登录接口
export function phoneLogin(data) {
  return request({
    url: '/tcloud-sso/account/phoneLogin',
    method: 'get',
    params: data
  })
}

// 手机登录接口，多个账号选择账号登录
export function phoneLoginWithAccount(data) {
  return request({
    url: '/tcloud-sso/account/phoneLoginWithAccount',
    method: 'get',
    params: data
  })
}

export function listMessage(data) {
  return request({
    url: '/aggregateservice-web/api/message/listMessage',
    method: 'post',
    data
  })
}

export function getMessage(data) {
  return request({
    url: '/aggregateservice-web/api/message/getMessage',
    method: 'post',
    data
  })
}

export function deleteMessage(data) {
  return request({
    url: '/aggregateservice-web/api/message/deleteMessage',
    method: 'post',
    data
  })
}

export function setReadStatus(data) {
  return request({
    url: '/aggregateservice-web/api/message/setReadStatus',
    method: 'post',
    data
  })
}

export function setAllReadStatus(data) {
  return request({
    url: '/aggregateservice-web/api/message/setAllReadStatus',
    method: 'post',
    data
  })
}

// 查看用户的认证信息概要
export function getAuthenticationInfoSummary() {
  return request({
    url: `${sys}/authentication/getAuthenticationInfoSummary`,
    method: 'get'
  })
}